/// ADMIN PANEL CODE *WITH FILTER ICON* ///
import React, { useState, useEffect } from "react";
import {
  TextField,
  Typography,
  Container,
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Menu,
  MenuItem,
  Card,
  CardContent,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  Grid,
  FormControl,
  InputAdornment,
  InputLabel,
  Select,
  ListItemIcon,
  CircularProgress,
} from "@mui/material";
// import { useNavigate } from "react-router-dom";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Search } from "@mui/icons-material";
import UserIconAP from "../../../images/UserIconAP.svg";
import SingleUserIcon from "../../../images/SingleUserIcon.svg";
import TokenConsumption from "../../../images/TokenConsumption.svg";

import DownloadIcon from "../../../images/DownloadIcon.svg";
import CreateArrow from "../../../images/CreateArrow.svg";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseIcon from "@mui/icons-material/Close";
import * as XLSX from "xlsx";

import {
  createUser,
  deleteUser,
  editUser,
  getAllProjectsByAdmin,
  getAllUsers,
} from "../../../services/webServices.js";
import SessionExpired from "../../popup-components/SessionExpiredPopup.js";

const AdminPanel = () => {
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [usercreatedmessage, setUsercreatedMessage] = useState("");
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("info");
  const [editingUser, setEditingUser] = useState(null);
  const [displayName, setDisplayName] = useState("");
  const [projectName, setProjectName] = useState("");
  const [getprojects, getSetProjects] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  // const [projects, setProjects] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [userToUpdate, setUserToUpdate] = useState(null);
  const [designation, setDesignation] = useState("");
  const [divisionalUnit, setDivisionalUnit] = useState("");
  const [ProjectID, setProjectID] = useState("");
  const [view, setView] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("All Status");
  const [sessionTime, setSessionTime] = useState(false);
  const [totalTasksDone, setTotalTasksDone] = useState(0);
  const [successMessageforupdateuser, setSuccessMessageforupdateuser] =
    useState(""); // State to hold the success message

  const [selectedUser, setSelectedUser] = useState(null);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    role: "",
    project: "",
    divisionalUnit: "",
  });

  const handleCloseDialog = () => {
    setUserToDelete(null);
    setOpenDialog(false);
  };

  const handleView = (user) => {
    setEditingUser(user);
    setUserToUpdate(user);
    setDisplayName("");
    setDesignation("");
    setProjectName("");
    setUsername("");
    setDivisionalUnit("");
    setView(false);
    setAnchorEl(null);
  };

  //function to update the user
  const handleCreateView = () => {
    if (!selectedUser) return; // Prevent issues if `selectedUser` is null
    setDisplayName(selectedUser.display_name || "");
    setDesignation(selectedUser.designation || "");
    setProjectID(selectedUser.project_id || "");
    setDivisionalUnit(selectedUser.du || "");
    setUsername(selectedUser.username || "");
    setView(true); // Open dialog AFTER setting values
  };

  const handleUpdateUser = async (e) => {
    e.preventDefault();
    
    // Clear the message first to ensure it refreshes
    setSuccessMessageforupdateuser("");
    
    try {
      await editUser({
        id: userToUpdate.id,
        displayName: displayName,
        // projectName: projectName,
        project_id: ProjectID,
        designation: designation,
        divisionalUnit: divisionalUnit,
      });

      // Set the success message after clearing
      setSuccessMessageforupdateuser(
        "User details have been successfully updated!"
      );
      setSeverity("success");
      setEditingUser(null);
      // setView(false); // closes the form upon clicking update user button
      // setDisplayName("");
      // setUsername("");
      // setProjectName("");
      // setDesignation("");
      // setDivisionalUnit("");
      // setProjectID("");
      getUsers();
    } catch (error) {
      if (error.response && error.response.data) {
        setMessage(error.response.data.Error);
      } else {
        setMessage("An unexpected error occurred.");
      }
      setSeverity("error");
    }
  };

  //Logout function
  const handleIconclose = () => {
    setView(false);
    setAnchorEl(null);
    setSeverity("success");
    setEditingUser(null);
    setDisplayName("");
    setUsername("");
    setProjectName("");
    setDesignation("");
    setDivisionalUnit("");
    setProjectID("");
    setSuccessMessageforupdateuser("");
  };

  const handleMenuOpen = (event, user) => {
    setAnchorEl(event.currentTarget);
    setSelectedUser(user);
    setUserToUpdate(user);
  };

  const handleMenuClose = () => {
    setAnchorEl(false);
  };

  const handleCreateClick = () => {
    setFormData({ email: "", name: "", role: "", project: "" }); // Reset form data
    setOpen(true);
  };

  const handleClose = () => {
    // setDisplayName("");
    // setDesignation("");
    // setProjectName("");
    // setUsername("");
    // setDivisionalUnit("");
    setFormData({ email: "", name: "", role: "", project: "" }); // Reset form
    setOpen(false);
  };

  const downloadReport = () => {
    let tableData = filteredUsers.map((user) => ({
      "User ID": user.id || "N/A",
      "User Name": user.display_name || "N/A",
      "Role / Designation": user.designation || "N/A",
      "Total Tasks Done": user.tasks_done || "0",
      "Token Used": user.tokens_used || "0",
      Status: user.status
        ? user.status.charAt(0).toUpperCase() + user.status.slice(1)
        : "N/A",

      // "Avg Session Time": user.avg_session_time
      //   ? `${(user.avg_session_time / 3600).toFixed(3)} hr`
      //   : "N/A",

      // "Last Login": user.last_login || "N/A",
    }));

    // Create worksheet & workbook
    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users Report");

    // Apply column width formatting
    const columnWidth = 25; // Set uniform width for all columns
    const columnCount = Object.keys(tableData[0] || {}).length;
    worksheet["!cols"] = new Array(columnCount).fill({ wch: columnWidth });

    // Generate dynamic file name
    const fileName = `Users Report.xlsx`;

    // Trigger file download
    XLSX.writeFile(workbook, fileName);
  };

  //Functionality to GET Users
  // const getUsers = async () => {
  //   const dates={fromDate,toDate};
  //   try {
  //     const response = await getAllUsers(dates);
  //     const totalTasksDone = response.data.totalServicesUsed;
  //     setTotalTasksDone(totalTasksDone);
  //     setUsers(response.data.data || []);
  //   } catch (error) {
  //     console.log("Error fetching users:", error.response.data.message);
  //     if (error.response.data.message === "Your session has expired.") {
  //       setSessionTime(true);
  //     }
  //     console.error("Failed to fetch users:", error);
  //   }
  // };

  //Functionality to get users
  const getUsers = async () => {
    const dates = { fromDate, toDate };
    try {
      const response = await getAllUsers(dates);
      const totalTasksDone = response.data.totalServicesUsed;
      setTotalTasksDone(totalTasksDone);
      setUsers(response.data.data || []);
    } catch (error) {
      if (error.response.data.message === "Your session has expired.") {
        setSessionTime(true);
      }
      console.error("Failed to fetch users:", error);
    }
  };
  useEffect(() => {
    getUsers();
  }, [fromDate, toDate]);

  // const handleFilter = async () => {
  //   try {
  //     const dates = { fromDate, toDate };
  //     const response = await getAllUsers(dates);
  //     setUsers(response.data.data);
  //     setTotalTasksDone(response.data.totalServicesUsed);
  //   } catch (error) {
  //     console.log("Error fetching users:", error.response.data.message);
  //   }
  // };

  useEffect(() => {
    const fetchProjectsDropdown = async () => {
      try {
        const response = await getAllProjectsByAdmin();
        // console.log(response.data);
        getSetProjects(response.data); // Set the project data from the API response
      } catch (error) {
        console.error("Error fetching projects:", error);
      }
    };

    fetchProjectsDropdown();
  }, []);

  // useEffect(() => {
  //   getUsers();
  //   // getAllProjectsByAdmin();
  // }, []);

  useEffect(() => {
    setFilteredUsers(users);
  }, [users]);

  const [newUsersCount, setNewUsersCount] = useState(0);

  useEffect(() => {
    // Retrieve stored count from sessionStorage
    const storedCount = sessionStorage.getItem("newUsersCount");
    if (storedCount) {
      setNewUsersCount(parseInt(storedCount));
    }
  }, []);

  //Functionality TO ADD NEW USER
  const handleSave = async (e) => {
    setLoading(true);
    e.preventDefault();
    setFormData({}); // Reset form
    try {
      const response = await createUser({
        username,
        displayName,
        designation,
        divisionalUnit,
        ProjectID,
      });
      // setMessage(`User created: ${response.data.username}`);
      setUsercreatedMessage(`User created: ${response.data.username}`);

      setNewUsersCount((prevCount) => {
        const newCount = prevCount + 1;
        sessionStorage.setItem("newUsersCount", newCount); // Persist the new count
        return newCount;
      });

      setDisplayName("");
      setUsername("");
      setProjectName("");
      setDesignation("");
      setDivisionalUnit("");
      setProjectID("");
      setSelectedStatus("All Status");
      setSeverity("success");
      getUsers();
      //  setOpen(false);
    } catch (error) {
      setUsercreatedMessage(
        error.response.data.Error || error.response.data.message
      );
      setMessage(error.response.data.Error || error.response.data.message);
      setSeverity("error");
    } finally {
      setLoading(false);
    }
  };
  // const handleSearch = (e) => {
  //   const query = e.target.value.toLowerCase();
  //   setSearchQuery(query);

  //   if (!query) {
  //     setFilteredUsers(users); // Reset to all users if query is empty
  //     return;
  //   }

  //   const filtered = users.filter((user) => {
  //     const nameMatch = user.display_name?.toLowerCase().includes(query);
  //     const designationMatch = user.designation?.toLowerCase().includes(query);
  //     return nameMatch || designationMatch; // Filter by either name or designation
  //   });

  //   setFilteredUsers(filtered);
  //   console.log("Filtered data", filtered);
  //   console.log("users : ", users);
  // };

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    let filtered = users;

    // Apply search filter if query exists
    if (query) {
      filtered = filtered.filter((user) => {
        const nameMatch = user.display_name?.toLowerCase().includes(query);
        const designationMatch = user.designation
          ?.toLowerCase()
          .includes(query);
        return nameMatch || designationMatch;
      });
    }

    // Apply status filter if selectedStatus is not "All Status"
    if (selectedStatus !== "All Status") {
      filtered = filtered.filter(
        (user) => user.status?.toLowerCase() === selectedStatus.toLowerCase()
      );
    }

    setFilteredUsers(filtered);
    // console.log("Filtered data", filtered);
  };

  // Handle status filter change
  // const handleStatusChange = (e) => {
  //   const status = e.target.value;
  //   setSelectedStatus(status);

  //   let filtered = users;

  //   // Apply search filter if a query exists
  //   if (searchQuery) {
  //     filtered = filtered.filter((user) => {
  //       const nameMatch = user.display_name
  //         ?.toLowerCase()
  //         .includes(searchQuery);
  //       const designationMatch = user.designation
  //         ?.toLowerCase()
  //         .includes(searchQuery);
  //       return nameMatch || designationMatch;
  //     });
  //   }

  //   // Apply status filter if selectedStatus is not "All Status"
  //   if (status !== "All Status") {
  //     filtered = filtered.filter(
  //       (user) => user.status?.toLowerCase() === status.toLowerCase()
  //     );
  //   }

  //   setFilteredUsers(filtered);
  // };

  const handleIconclosecreateuser = () => {
    setOpen(false);
    setAnchorEl(null);
    setDisplayName("");
    setUsername("");
    setProjectName("");
    setDesignation("");
    setDivisionalUnit("");
    setProjectID("");
    setUsercreatedMessage("");
  };
  //Functionality to delete user
  const handleDeleteUser = async (id) => {
    try {
      await deleteUser(id);
      setAnchorEl(false);
      setMessage("User deleted successfully.");
      setSeverity("success");
      getUsers();
    } catch (error) {
      setMessage(error.response.data.Error);
      setSeverity("error");
      console.error(error);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        bgcolor: "#F5F5F2",
        height: "calc(100vh - 150px)", // adjust as needed
        overflowY: "auto",
        maxHeight: "100vh",
      }}
    >
      <Container
        component="main"
        maxWidth={false}
        sx={{ marginLeft: "10px", marginRight: "10px" }}
      >
        <Box sx={{ my: 1 }}>
          <Box
            sx={{
              my: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" component="h1" gutterBottom>
              Users
            </Typography>
            <Box sx={{ display: "flex", gap: 2 }}>
              {/* Create Button */}
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#0094FB",
                  color: "white",
                  textTransform: "none",
                }}
                endIcon={
                  <img
                    src={CreateArrow}
                    alt="Dropdown"
                    style={{ width: 16, height: 16, marginLeft: "5px" }}
                  />
                }
                onClick={handleCreateClick}
              >
                Add User
              </Button>
              {/* Download Report Button */}
              <Button
                variant="outlined"
                sx={{
                  backgroundColor: "white",
                  color: "#0094FB",
                  border: "1px solid #0094FB",
                  textTransform: "none",
                }}
                endIcon={
                  <img
                    src={DownloadIcon}
                    alt="Download"
                    style={{ width: 16, height: 16, marginLeft: "5px" }}
                  />
                }
                onClick={downloadReport}
              >
                <b>Download Report</b>
              </Button>
            </Box>
          </Box>

          {/*  Create User Dialog POPUP */}
          <Dialog open={open} onClose={handleClose}>
            <DialogTitle>
              Create User
              <IconButton
                onClick={handleIconclosecreateuser} // Close dialog when clicked
                sx={{
                  position: "absolute", // Position the close button absolutely
                  top: "8px", // Adjust distance from top
                  right: "8px", // Adjust distance from right
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <TextField
                margin="dense"
                label="Name"
                name="name"
                fullWidth
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
              />
              <TextField
                margin="dense"
                label="Email Address"
                name="email"
                fullWidth
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
              <TextField
                margin="dense"
                label="Designation"
                name="role"
                fullWidth
                value={designation}
                onChange={(e) => setDesignation(e.target.value)}
              />
              {/* <TextField
                margin="dense"
                label="Project Name"
                name="project"
                fullWidth
                value={projectName}
                onChange={(e) => setProjectName(e.target.value)}
              /> */}
              <FormControl fullWidth margin="dense">
                <InputLabel id="project-name-label">Project Name</InputLabel>
                <Select
                  labelId="project-name-label"
                  value={ProjectID || ""}
                  label="Project Name"
                  onChange={(e) => setProjectID(e.target.value)}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                        width: 250,
                      },
                    },
                  }}
                >
                  
                  {getprojects.map((projects) => (
                    <MenuItem
                      key={projects.project_id}
                      value={projects.project_id}
                    >
                      {projects.project_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                margin="dense"
                label="Delivery Unit"
                name="DU"
                fullWidth
                value={divisionalUnit}
                onChange={(e) => setDivisionalUnit(e.target.value)}
              />
              {usercreatedmessage && (
                <Box sx={{ mt: 2, color: "blue", fontSize: "18px" }}>
                  {usercreatedmessage}
                </Box>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                sx={{
                  textTransform: "none",
                  fontSize: 17,
                  backgroundColor: "#0094FB",
                }}
                onClick={handleSave}
                color="primary"
                disabled={
                  !displayName || !username || !designation || !ProjectID
                }
              >
                {/* {loading ? <CircularProgress size={24} /> : "Create"} */}
                {loading && (
                  <CircularProgress
                    size={24}
                    // sx={{ marginRight: 1 }}
                  />
                )}
                {"Create"}
              </Button>
            </DialogActions>
          </Dialog>

          {/* === 3 Equal-Spaced Cards === */}
          <Grid
            container
            spacing={3}
            sx={{ marginBottom: "20px", marginTop: "-10px" }}
          >
            {" "}
            {/* Move cards up */}
            {/* total users card */}
            <Grid item xs={12} sm={4}>
              <Card
                sx={{
                  padding: "15px",
                  borderRadius: "12px",
                  boxShadow: "none",
                  border: "1px solid #ddd",
                  height: "110px",
                  position: "relative", // Ensures footer sticks at bottom
                }}
              >
                <CardContent sx={{ paddingBottom: "50px" }}>
                  {" "}
                  {/* Space for footer */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginTop: "-30px",
                    }}
                  >
                    <img
                      src={SingleUserIcon}
                      alt="User Icon"
                      style={{
                        width: "50px",
                        height: "80px",
                        marginLeft: "-20px",
                      }}
                    />
                    <Box>
                      <Typography variant="p" color="textSecondary">
                        Total Users
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <Typography variant="h6">{users.length}</Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "green",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          ⬈ {newUsersCount} New Users
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </CardContent>

                {/* Footer with full-width grey background */}
                <Box
                  sx={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: "100%",
                    backgroundColor: "#f0f0f0",
                    padding: "10px",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      px: 2,
                    }}
                  >
                    <Typography variant="body1" sx={{ color: "grey" }}>
                      Active:{" "}
                      <span style={{ color: "black" }}>
                        {
                          users.filter(
                            (user) => user.status?.toLowerCase() === "active"
                          ).length
                        }
                      </span>
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: "grey", marginRight: "10px" }}
                    >
                      Inactive:{" "}
                      <span style={{ color: "red" }}>
                        {
                          users.filter(
                            (user) => user.status?.toLowerCase() === "inactive"
                          ).length
                        }
                      </span>
                    </Typography>
                  </Box>
                </Box>
              </Card>
            </Grid>
            {/* total time spent card */}
            <Grid item xs={12} sm={4}>
              <Card
                sx={{
                  padding: "15px",
                  borderRadius: "12px",
                  boxShadow: "none",
                  border: "1px solid #ddd",
                  height: "110px",
                  position: "relative", // Ensures footer sticks to bottom
                }}
              >
                <CardContent sx={{ paddingBottom: "50px" }}>
                  {" "}
                  {/* Space for footer */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginTop: "-30px",
                    }}
                  >
                    <img
                      src={UserIconAP}
                      alt="User Icon"
                      style={{
                        width: "50px",
                        height: "80px",
                        marginLeft: "-20px",
                      }}
                    />
                    <Box>
                      <Typography variant="p" color="textSecondary">
                        Total Services Used
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <Typography variant="h6">{totalTasksDone}</Typography>
                      </Box>
                    </Box>
                  </Box>
                </CardContent>

                {/* Footer with full-width grey background */}
                <Box
                  sx={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: "100%",
                    backgroundColor: "#f0f0f0",
                    padding: "10px",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      px: 2,
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ color: "grey", marginLeft: "-10px" }}
                    >
                      {/* <span style={{ color: "black" }}>
                        {users.length > 0
                          ? (
                              users.reduce(
                                (total, user) => total + (user.avg_session_time || 0),
                                0
                              ) / users.length
                            ).toFixed(2)
                          : 0}{" "}
                        hr
                      </span> */}
                      {/* <span style={{ color: "black" }}>
                        {users.length > 0
                          ? (
                              users.reduce(
                                (total, user) =>
                                  total + (user.avg_session_time || 0),
                                0
                              ) /
                              users.length /
                              3600
                            ) // Divide by 3600 to convert to hours
                              .toFixed(2)
                          : 0}{" "}
                        hr
                      </span> */}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: "grey", marginRight: "10px" }}
                    >
                      {/* <span style={{ color: "green" }}>
                        {users.length > 0
                          ? (
                              53 -
                              users.reduce(
                                (total, user) => total + (user.time_spent || 0),
                                0
                              ) /
                                users.length
                            ).toFixed(1)
                          : 0}
                        hr/user
                      </span> */}
                    </Typography>
                  </Box>
                </Box>
              </Card>
            </Grid>
            {/* token consumption card */}
            <Grid item xs={12} sm={4}>
              <Card
                sx={{
                  padding: "15px",
                  borderRadius: "12px",
                  boxShadow: "none",
                  border: "1px solid #ddd",
                  height: "110px",
                  position: "relative", // Ensure footer stays at the bottom
                }}
              >
                <CardContent sx={{ paddingBottom: "50px" }}>
                  {" "}
                  {/* Space for footer */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginTop: "-30px",
                    }}
                  >
                    <img
                      src={TokenConsumption}
                      alt="Token Icon"
                      style={{
                        width: "50px",
                        height: "80px",
                        marginLeft: "-20px",
                      }}
                    />
                    <Box>
                      <Typography variant="body2" color="textSecondary">
                        Token Consumption
                      </Typography>
                      <Typography variant="h6">
                        {users.reduce(
                          (total, user) =>
                            total + (parseInt(user.tokens_used) || 0),
                          0
                        )}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>

                {/* Footer with full-width grey background */}
                <Box
                  sx={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: "100%",
                    backgroundColor: "#f0f0f0",
                    padding: "10px",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      px: 2,
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ color: "grey", marginLeft: "-10px" }}
                    >
                      Total:
                      {/* <span style={{ color: "black" }}> 4000 </span> */}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: "grey", marginRight: "20px" }}
                    >
                      Remaining:{" "}
                      {/* <span style={{ color: "red" }}>
                        {4000 -
                          users.reduce(
                            (total, user) => total + (user.token_used || 0),
                            0
                          )}
                      </span> */}
                    </Typography>
                  </Box>
                </Box>
              </Card>
            </Grid>
          </Grid>

          {/* === End of Cards === */}

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 2,
            }}
          >
            {/* Search Bar */}

            <Box sx={{ flex: 1, maxWidth: "280px", background: "#FFFFFF" }}>
              <TextField
                variant="outlined"
                placeholder="Search Name/Role"
                value={searchQuery}
                onChange={handleSearch}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                    sx: { height: "30px" },
                  },
                }}
                sx={{ width: "100%", borderRadius: "20px" }}
              />
            </Box>

            {/* Dropdown Filters */}
            <Box
              sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}
            >
              <TextField
                label="From"
                variant="outlined"
                margin="normal"
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={
                  {
                    // width: "40%",
                    // "& .MuiOutlinedInput-root": { padding: "4px 14px" },
                  }
                } // Adjust padding to reduce height
              />

              <TextField
                label="To"
                variant="outlined"
                margin="normal"
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                // sx={{ width: "40%" }}
              />
            </Box>
          </Box>

          {/* User Table */}
          <TableContainer component={Paper} sx={{ mt: 3 }}>
            <Table sx={{ minWidth: 650, borderCollapse: "collapse" }}>
              <TableHead>
                <TableRow
                  sx={{
                    borderBottom: "1px solid #ddd",
                    backgroundColor: "white",
                  }}
                >
                  <TableCell
                    sx={{ padding: "8px", borderRight: "1px solid #ddd" }}
                  >
                    <input type="checkbox" />
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "8px",
                      borderRight: "1px solid #ddd",
                      color: "grey",
                    }}
                  >
                    User ID
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "8px",
                      borderRight: "1px solid #ddd",
                      color: "grey",
                    }}
                  >
                    User Name
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "8px",
                      borderRight: "1px solid #ddd",
                      color: "grey",
                    }}
                  >
                    Role / Designation
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "8px",
                      borderRight: "1px solid #ddd",
                      color: "grey",
                    }}
                  >
                    DU
                  </TableCell>

                  <TableCell
                    sx={{
                      padding: "8px",
                      borderRight: "1px solid #ddd",
                      color: "grey",
                    }}
                  >
                    Total Tasks Done
                  </TableCell>
                  {/* <TableCell
                    sx={{
                      padding: "8px",
                      borderRight: "1px solid #ddd",
                      color: "grey",
                    }}
                  >
                    Avg Session Time
                  </TableCell> */}
                  <TableCell
                    sx={{
                      padding: "8px",
                      borderRight: "1px solid #ddd",
                      color: "grey",
                    }}
                  >
                    Tokens Used
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "8px",
                      borderRight: "1px solid #ddd",
                      color: "grey",
                      width: "100px",
                    }}
                  >
                    Status
                  </TableCell>
                  {/* <TableCell
                    sx={{
                      padding: "8px",
                      borderRight: "1px solid #ddd",
                      color: "grey",
                    }}
                  >
                    Last Login
                  </TableCell> */}
                  <TableCell sx={{ padding: "8px", width: "20px" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredUsers.map((user) => (
                  <TableRow
                    key={user.id}
                    sx={{ borderBottom: "1px solid #ddd" }}
                  >
                    <TableCell
                      sx={{ padding: "6px", borderRight: "1px solid #ddd" }}
                    >
                      <input type="checkbox" />
                    </TableCell>
                    <TableCell
                      sx={{ padding: "6px", borderRight: "1px solid #ddd" }}
                    >
                      {user.id}
                    </TableCell>
                    <TableCell
                      sx={{ padding: "6px", borderRight: "1px solid #ddd" }}
                    >
                      {user.display_name}
                    </TableCell>
                    <TableCell
                      sx={{ padding: "6px", borderRight: "1px solid #ddd" }}
                    >
                      {user.designation}
                    </TableCell>

                    <TableCell
                      sx={{ padding: "6px", borderRight: "1px solid #ddd" }}
                    >
                      {user.du}
                    </TableCell>

                    <TableCell
                      sx={{ padding: "6px", borderRight: "1px solid #ddd" }}
                    >
                      {user.tasks_done}
                    </TableCell>
                    {/* <TableCell
                      sx={{ padding: "6px", borderRight: "1px solid #ddd" }}
                    >
                      {(user.avg_session_time / 3600).toFixed(3)} hrs
                    </TableCell> */}
                    <TableCell
                      sx={{ padding: "6px", borderRight: "1px solid #ddd" }}
                    >
                      {user.tokens_used}
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "6px",
                        borderRight: "1px solid #ddd",
                        //fontWeight: "bold"
                      }}
                    >
                      <span
                        style={{
                          color:
                            user.status?.toLowerCase() === "active"
                              ? "#4CAF50"
                              : "#F44336",
                          backgroundColor:
                            user.status?.toLowerCase() === "active"
                              ? "#E8F5E9"
                              : "#FFEBEE",
                          padding: "4px 8px",
                          borderRadius: "4px",
                          border:
                            user.status?.toLowerCase() === "active"
                              ? " #4CAF50"
                              : " #F44336",
                        }}
                      >
                        {user.status.charAt(0).toUpperCase() +
                          user.status.slice(1).toLowerCase()}

                        {/* {user.status} */}
                      </span>
                    </TableCell>
                    {/* <TableCell
                      sx={{ padding: "6px", borderRight: "1px solid #ddd" }}
                    >
                      {user.last_login}
                    </TableCell> */}
                    <TableCell sx={{ padding: "6px", width: "50px" }}>
                      <IconButton
                        onClick={(e) => handleMenuOpen(e, user)}
                        size="small"
                      >
                        <MoreVertIcon fontSize="small" />
                      </IconButton>

                      {/* Delete Confirmation Dialog */}
                      <Dialog
                        open={openDialog}
                        onClose={handleCloseDialog}
                        PaperProps={{
                          sx: {
                            maxWidth: "300px",
                            minWidth: "300px",
                            borderRadius: "8px",
                            boxShadow: "none",
                            padding: "16px",
                            p: 1,
                          },
                        }}
                        slotProps={{
                          backdrop: {
                            sx: {
                              backgroundColor: "rgba(0, 0, 0, 0.025)", // Adjusted for better visibility
                            },
                          },
                        }}
                      >
                        <DialogTitle sx={{ pb: 1, fontSize: "1.2rem" }}>
                          Delete User
                        </DialogTitle>
                        <DialogContent sx={{ pb: 2 }}>
                          <Typography>
                            Are you sure you want to delete{" "}
                            <strong>{userToDelete?.display_name}</strong>?
                          </Typography>
                        </DialogContent>
                        <DialogActions sx={{ px: 2, pb: 2 }}>
                          <Button
                            onClick={handleCloseDialog}
                            variant="outlined"
                            size="small"
                          >
                            Cancel
                          </Button>
                          <Button
                            onClick={() => {
                              handleDeleteUser(userToDelete?.id);
                              handleCloseDialog();
                            }}
                            color="error"
                            variant="contained"
                            size="small"
                          >
                            Delete
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* Dropdown Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          slotProps={{
            paper: {
              elevation: 3,
              sx: {
                border: "1px solid #D9D9D9",
                borderRadius: "8px",
                minWidth: "160px",
                boxShadow: "0px 4px 14px 0px rgba(66, 70, 94, 0.20);",
              },
            },
          }}
        >
          {/* View Details */}
          <MenuItem onClick={handleCreateView}>
            <ListItemIcon>
              <VisibilityOutlinedIcon
                fontSize="small"
                sx={{ color: "#007BFF" }}
              />
            </ListItemIcon>
            <Typography variant="body2">View Details</Typography>
          </MenuItem>

          {/* Assign Project */}
          {/* <MenuItem
            onClick={() =>
              alert(`Assign Project to ${selectedUser?.display_name}`)
            }
          >
            <ListItemIcon>
              <AssignmentOutlinedIcon
                fontSize="small"
                sx={{ color: "#007BFF" }}
              />
            </ListItemIcon>
            <Typography variant="body2">Assign Project</Typography>
          </MenuItem> */}

          {/* Delete User */}
          <MenuItem
            sx={{ color: "red" }}
            onClick={() => {
              if (selectedUser?.id) {
                setUserToDelete(selectedUser);
                setOpenDialog(true);
              }
            }}
          >
            <ListItemIcon>
              <DeleteOutlineIcon fontSize="small" sx={{ color: "red" }} />
            </ListItemIcon>
            <Typography variant="body2" sx={{ color: "red" }}>
              Delete User
            </Typography>
          </MenuItem>
        </Menu>

        <Dialog
          open={view}
          onClose={handleView}
          slotProps={{
            backdrop: {
              sx: { backgroundColor: "rgba(0, 0, 0, 0.5)" }, // Removes dark overlay
            },
            paper: {
              sx: {
                boxShadow: "none", // Adds a subtle shadow for visibility
                borderRadius: "8px",
                padding: "16px",
                p: 1,
              },
            },
          }}
        >
          <DialogTitle
            sx={{
              position: "relative", // Make the title position relative so the button can be positioned absolutely
              paddingRight: "36px", // Space for the close button
            }}
          >
            View User Details
            <IconButton
              onClick={handleIconclose} // Close dialog when clicked
              sx={{
                position: "absolute", // Position the close button absolutely
                top: "8px", // Adjust distance from top
                right: "8px", // Adjust distance from right
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              label="Display Name"
              name="name"
              fullWidth
              value={displayName}
              onChange={(e) => {
                console.log(e);
                setDisplayName(e.target.value);
              }}
            />
            <TextField
              margin="dense"
              label="User Name"
              name="user name"
              fullWidth
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <FormControl fullWidth margin="dense">
              <InputLabel id="project-name-label">Project Name</InputLabel>
              <Select
                labelId="project-name-label"
                value={ProjectID}
                label="Project Name"
                onChange={(e) => setProjectID(e.target.value)}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      width: 250,
                    },
                  },
                }}
              >
                {getprojects.map((projects) => (
                  <MenuItem
                    key={projects.project_id}
                    value={projects.project_id}
                  >
                    {projects.project_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              margin="dense"
              label="Role/Designation"
              name="role"
              fullWidth
              value={designation}
              onKeyDown={(e) => console.log(e)}
              onChange={(e) => {
                setDesignation(e.target.value);
              }}
            />
            <TextField
              margin="dense"
              label="Delivery Unit"
              name="DU"
              fullWidth
              value={divisionalUnit}
              onChange={(e) => setDivisionalUnit(e.target.value)}
            />
            <br />
            <br />

            {successMessageforupdateuser && (
              <Box sx={{ mt: 2, color: "blue", fontSize: "18px" }}>
                {successMessageforupdateuser}
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleUpdateUser}
              color="primary"
              sx={{ textTransform: "none", fontSize: 18 }}
            >
              Update user
            </Button>
          </DialogActions>
        </Dialog>
      </Container>

      {sessionTime && <SessionExpired />}
    </Box>
  );
};

export default AdminPanel;